import React from 'react';
// import { Layout } from 'antd';
import './Layout.css';
import moment from 'moment';
import {useTranslation} from "@nic-react-i18n/core";

// import PageHeader from 'ant-design-pro/lib/PageHeader';

export interface LayoutProps {
    header: React.ReactElement;
    main: React.ReactElement;
}

export interface MainLayoutProps {
    components: LayoutProps;
}

const MainLayout: React.FC<MainLayoutProps> = (props) => {

    const {components} = props;
    const {t} = useTranslation()

    const header = React.cloneElement(components.header, {...props});
    const main = React.cloneElement(components.main, {...props});
    const year = moment().year();
    return (

        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                flexWrap: 'nowrap',
                minHeight: '100vh'
            }}
        >
            <div
            >
                {header}
            </div>
            <div
                style={{
                    padding: '0 50px', marginTop: '1vh', position: 'relative', flex: 1
                }}
            >
                <>{main}</>
            </div>
            <footer>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignContent: 'center',
                        alignItems: 'center',
                        height: '5vh',
                        backgroundColor: 'white',
                        borderTop: '1px solid #e8e8e8',
                    }}
                >
                        <span style={{fontSize: '1rem'}}>
                        {t('footer.signature', {year: year})}
                        </span>
                    <span>
                            <a href={'http://www.nic.it'}>
                            <img
                                style={{height: '4vh'}}
                                alt={'registro.it logo'}
                                src={'/logoRegistroNew.svg'}
                            />
                            </a>
                        </span>
                </div>
            </footer>
        </div>

    );
}
export default MainLayout